import { render, staticRenderFns } from "./DraftOrderList.vue?vue&type=template&id=afa2f284&scoped=true&"
import script from "./DraftOrderList.vue?vue&type=script&lang=js&"
export * from "./DraftOrderList.vue?vue&type=script&lang=js&"
import style0 from "./DraftOrderList.vue?vue&type=style&index=0&id=afa2f284&lang=scss&scoped=true&"
import style1 from "./DraftOrderList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2f284",
  null
  
)

export default component.exports